
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function FinalCTASection() {
  return (
    <section 
      className="py-20 bg-cover bg-center bg-no-repeat relative"
      style={{
        backgroundImage: `linear-gradient(rgba(27, 54, 93, 0.9), rgba(43, 182, 163, 0.9)), url('https://public.readdy.ai/ai/img_res/92c630212cbada5cf1fa45f3a8f77907.jpg')`
      }}
    >
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-5xl font-bold mb-6">
            Ready to Build Your Predictable Revenue System?
          </h2>
          <p className="text-xl mb-8 opacity-90 max-w-3xl mx-auto">
            Stop leaving your revenue to chance. Book a free strategy call and discover how 
            AI-powered systems can transform your service business into a predictable growth engine.
          </p>
          
          {/* Value Props */}
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="text-center">
              <div className="w-16 h-16 bg-[#2BB6A3] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-check-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Free 45-Minute Call</h3>
              <p className="text-sm opacity-80">No sales pitch, just value</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#2BB6A3] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-search-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Revenue Assessment</h3>
              <p className="text-sm opacity-80">Identify growth opportunities</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#2BB6A3] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-roadmap-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Custom Roadmap</h3>
              <p className="text-sm opacity-80">Tailored growth strategy</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/book-call">
              <Button 
                variant="primary" 
                size="large"
                className="bg-[#2BB6A3] hover:bg-[#2BB6A3]/90 text-white px-8 py-4 text-lg font-semibold whitespace-nowrap"
              >
                Book Your Free Strategy Call
              </Button>
            </Link>
            <Link to="/free-assessment">
              <Button 
                variant="secondary" 
                size="large"
                className="border-2 border-white text-white hover:bg-white hover:text-[#1B365D] px-8 py-4 text-lg font-semibold whitespace-nowrap"
              >
                Get Free Assessment
              </Button>
            </Link>
          </div>

          <p className="text-sm opacity-70 mt-6">
            Join 75+ service companies that have transformed their revenue operations
          </p>
        </div>
      </div>
    </section>
  );
}
